import React, { useState } from 'react';
import { mode } from '@chakra-ui/theme-tools';
import {
  Center,
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Button,
  Input,
  Select,
  useToast,
  Stack,
  Box,
  FormControl,
  FormLabel,
  Switch,
} from '@chakra-ui/react';
import Card from 'components/card/Card';
import AllPermissionsTable from './allPermissionsTable';
import SelectedPermissionsTable from './selectedPermisssionsTable';
import { useSelectedPermissions } from 'contexts/PermissionGroupArrayContext';

const SelectionTables = ({ disabled }) => {
  const { selectedPermissions } = useSelectedPermissions();

  return (
    <Flex
      mt={7}
      direction={{ base: 'column', xl: 'row' }}
      width='100%'
      justify='space-between'
      gap={6}>
      {disabled ? (
        <></>
      ) : (
        <Flex
          width='100%'
          maxWidth='7xl'>
          <Card bgColor='gray.200'>
            <Flex
              direction={'row'}
              justify={'space-between'}>
              <Flex>
                <Text
                  fontSize='xl'
                  // color='blue.400'
                  fontWeight='300'>
                  Select from Permissions below :
                </Text>
              </Flex>
              <Flex
                direction={'row'}
                gap={4}
                mr={4}
                display={{ base: 'block', xl: 'none' }}>
                <Text
                  fontSize='xl'
                  // color='blue.400'
                  fontWeight='300'>
                  Selected Permissions :
                </Text>
                <Text
                  fontSize='xl'
                  // color='blue.400'
                  fontWeight='700'>
                  {selectedPermissions.length}
                </Text>
              </Flex>
            </Flex>

            <AllPermissionsTable />
          </Card>
        </Flex>
      )}

      <Flex
        width='100%'
        maxWidth='7xl'
        display={{ base: disabled ? 'block' : 'none', xl: 'block' }}>
        <Card bgColor='gray.200'>
          <Flex
            direction={'row'}
            gap={4}>
            <Text
              fontSize='xl'
              // color='blue.400'
              fontWeight='300'>
              Selected Permissions :
            </Text>
            <Text
              fontSize='xl'
              // color='blue.400'
              fontWeight='700'>
              {selectedPermissions.length}
            </Text>
          </Flex>
          <SelectedPermissionsTable />
        </Card>
      </Flex>
    </Flex>
  );
};

export default SelectionTables;
